import BeachNearbyPlaces from "@/components/yts/BeachNearbyPlaces";
import { useLang } from "@/lib/i18n";

const labelCls = "text-[9.5px] tracking-[0.14em] uppercase font-black text-[#9CA3AF]";

/** What a beach is good for: activities, conditions, facilities, and what's around. */
export default function BeachCardDetails({ beach }) {
  const { t } = useLang();

  return (
    <>
      {beach.activities?.length > 0 && (
        <div className="mt-3">
          <div className={labelCls}>{t("beach.activities")}</div>
          <div className="mt-1.5 flex flex-wrap gap-1.5">
            {beach.activities.map((activity) => (
              <span
                key={activity}
                className="px-2 py-1 rounded-full bg-[#FEF3E2] text-[#9A5B12] text-[10.5px] font-extrabold"
              >
                {activity}
              </span>
            ))}
          </div>
        </div>
      )}

      <dl className="mt-3 pt-3 border-t border-[#F3F4F6] grid grid-cols-2 gap-3">
        <div>
          <dt className={labelCls}>{t("beach.bestFor")}</dt>
          <dd className="mt-0.5 text-[12.5px] font-bold text-[#111827]">{beach.bestFor}</dd>
        </div>
        <div>
          <dt className={labelCls}>{t("beach.water")}</dt>
          <dd className="mt-0.5 text-[12.5px] font-bold text-[#111827]">{beach.water}</dd>
        </div>
        {beach.amenities?.length > 0 && (
          <div className="col-span-2">
            <dt className={labelCls}>{t("beach.amenities")}</dt>
            <dd className="mt-0.5 text-[12.5px] leading-[1.5] text-[#6B7280]">
              {beach.amenities.join(" · ")}
            </dd>
          </div>
        )}
      </dl>

      <BeachNearbyPlaces beach={beach} />
    </>
  );
}